import { BOOK_COUNT_LIST } from '@/constants/book';
import { BookSummaryResponse } from '@/types/book';
import { comma } from '@/util/format';
import styled from 'styled-components';

type Props = {
  countList?: BookSummaryResponse;
};

function ThreeMonthsCountSection({ countList }: Props) {
  const data = {
    reservationCount: 0,
    reservationConfirm: 0,
    visitConfirm: countList?.visitConfirm || 0,
  };

  return (
    <Section>
      {BOOK_COUNT_LIST.map(({ title, key }, index) => (
        <DetailSection key={key} isFirst={index === 0}>
          <DetailTitle>{title}</DetailTitle>
          <DetailData index={index}>
            <strong>{comma(data[key as keyof BookSummaryResponse])}</strong>명
          </DetailData>
        </DetailSection>
      ))}
    </Section>
  );
}

const Section = styled.dl`
  display: flex;
  gap: 20px;
  width: 100%;
`;

const DetailSection = styled.div<{ isFirst: boolean }>`
  background-color: #fff;
  border-radius: 16px;
  padding: 22px;
  flex-shrink: 0;
  width: ${({ isFirst }) =>
    isFirst ? 'calc(100% - 30% * 2 - 20px * 2)' : '30%'};
`;

const DetailTitle = styled.dt`
  color: #3a3b3e;
  font-size: 18px;
  font-weight: 700;
  line-height: 27px;
  margin-bottom: 16px;
`;

const DetailData = styled.dd<{ index: number }>`
  color: #80848a;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 27px;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  strong {
    color: ${({ index }) => (index === 0 ? '#246CF6' : '#5f6165')};
    font-size: 32px;
    font-weight: 700;
    line-height: 48px;
    margin-right: 4px;
  }
`;

export default ThreeMonthsCountSection;
